import { useContext } from "react";
import { OfficeContext, OfficeContextType } from "../containers/OfficeContainer/OfficeContainer";

const useOfficeContext = (): OfficeContextType => {
  return useContext(OfficeContext);
};

export default useOfficeContext;
